module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_4-WAY STRETCHABLE LEATHER_deskstop.e0ebc705.jpg";